module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    attrs: {
      "aria-label": "page x",
      "epub:type": "pagebreak",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page xi",
      "epub:type": "pagebreak",
      "id": "page_xi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page xii",
      "epub:type": "pagebreak",
      "id": "page_xii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 1",
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("S")]), _vm._v("pock awoke to chaos and agony—the wail of a red alert and a wave of excruciating pain. His limbs were numb and paralyzed, but he was plagued by a profound burning sensation across much of his back. His pulse throbbed in his temples, aggravating the crushing sensation gripping his skull.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Where am I? What has happened?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He forced open one eye. His view of the compartment was sideways and blurry. At first he saw nothing but varying degrees of shadow. Then an alert panel on a bulkhead pulsed, filling the room for a moment with crimson light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I am on the")]), _vm._v(" Enterprise. "), _c('i', [_vm._v("These are guest quarters")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything went dark again. Spock concentrated on overcoming the shock caused by whatever trauma his body had suffered. He drew a slow, deep breath and noted the acrid bite of smoke from a plasma fire mingled with the musky "), _c('span', {
    attrs: {
      "aria-label": "page 2",
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("scent of traditional Vulcan incense, the kind used for sacred rituals.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Pain is an illusion")]), _vm._v(". He summoned the mental discipline of his half-Vulcan heritage to overcome the physical limitations of his human half. "), _c('i', [_vm._v("It is a construct of the mind. I must master my mind and control my pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another flash of red light bathed the compartment. He blinked and saw two more people sprawled on the deck a few meters from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One was his father, the famed Vulcan diplomat Ambassador Sarek. The other was the "), _c('i', [_vm._v("Enterprise")]), _vm._v("’s senior communications officer and Spock’s human lover, Lieutenant Nyota Uhura. Both lay unconscious, their faces bruised and bloody.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darkness fell, and between the wails of the alert siren Spock heard a woman’s voice begin a monotonal chant in an ancient dialect of High Vulcan. It was not a ceremony he had ever heard spoken before. Some of its phrases were so obscure that he could not translate them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He labored to turn his head. It took all his strength to lift his chin from the deck and roll his head from left to right. A weak gasp of effort escaped his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chanting woman was Vulcan and slight of frame, and she wore her long hair gathered atop her head in a complicated coiffure. She was garbed in the ceremonial vestments of a Mount Seleya priestess, but even dim, fleeting glances in the ruddy half-light made it obvious the woman was far too young to have earned such a lofty status among Vulcan’s most revered philosophers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 3",
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Though he could not see what the woman held in her hands, he noted the Starfleet phaser lying on the deck by her feet, and a fragment of memory returned to him: "), _c('i', [_vm._v("She shot me as I entered")]), _vm._v(". Another off-key howl of the alert klaxon drowned out the woman’s chanting, and Spock struggled to focus his eyes on her profile.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a bloodred flash he saw her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was L’Nel, his father’s chief aide-de-camp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He rasped, “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She fixed him with a stare of cold fire. “One must die for the other to live.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spock’s mind was a flurry of questions, but his mouth—dry and filled with a sour taste—refused to form words. All he could do was watch L’Nel turn her back on him and continue intoning her eldritch chants to the smoky darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned his head away from her, hoping to see that either Sarek or Uhura had been roused to consciousness. Neither had stirred. As his eyes adjusted to the dim illumination, he became aware of the severity of Uhura’s injuries. The young human woman had been savagely beaten, and Spock grew concerned that she might be in urgent need of medical attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I must try to reach my communicator.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He closed his eyes and concentrated on moving his hand to his belt. When that proved too difficult, he tried instead to move his fingers, even if only a little, just to confirm for himself that he had not been rendered a quadriplegic by whatever L’Nel had done to him after stunning him with the phaser "), _c('span', {
    attrs: {
      "aria-label": "page 4",
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("blast. He felt a very human wave of frustration as his hand refused to obey his mind’s commands.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another whoop of the alarm was cut short, and the flashing red signal on the bulkhead dimmed and went out. From outside the room’s door, Spock heard the muffled voice of Mister Sulu over the intraship comm. He wondered for a moment why he had not heard the announcement inside the guest quarters, and then he deduced that the compartment’s comm system had been disabled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Which means its internal sensors are likely offline, as well")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With great effort he turned his head to look again at the Vulcan woman. All her attention seemed to be focused on the object in her hands, and she maintained a hypnotic cadence with her chanting. Then she turned, faced Spock, and strode toward him, focused and purposeful. As she kneeled beside him, he was able at last to see clearly the object she bore with such reverence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an urn whose color betrayed its composition of Vulcan clay, and the inscriptions carved in concentric rings on its exterior and lid marked it as a product of the reclusive "), _c('i', [_vm._v("Kolinahr")]), _vm._v(" masters on Mount Seleya. The skull-sized container was nearly identical to others Spock had seen in his youth, in the Halls of Ancient Thought on Vulcan—in the days before his homeworld had been obliterated in an act of irrational vengeance by Nero, a criminal from the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("L’Nel was holding a "), _c('i', [_vm._v("katric")]), _vm._v(" ark. The Vulcan artifact had one express purpose: to capture the "), _c('i', [_vm._v("katra")]), _vm._v("—the living essence of a Vulcan’s identity, all of one’s knowledge and memories—at "), _c('span', {
    attrs: {
      "aria-label": "page 5",
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("the moment of death and store it forever among those of its deceased kith and kin.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite his mental training, Spock felt alarm as the woman reached one hand toward his face to initiate a mind-meld. His alarm became fear as he discerned an icy gleam of malice in her dark eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please,” Spock whispered, “do not do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The time for mercy is past.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pressed her fingers roughly against the side of his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unable to flee, fight, or call for aid, all Spock could do was meet the stare of a madwoman and bear witness to his own murder.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91107468","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982140632/xhtml/ch01.vue
// module id = 78
// module chunks = 0